// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC8VTYco1dRyDz8cZ9i81q9Byjt3SY8BuI",
    authDomain: "task-notification-service.firebaseapp.com",
    databaseURL: "https://task-notification-service.firebaseio.com",
    projectId: "task-notification-service",
    storageBucket: "task-notification-service.appspot.com",
    messagingSenderId: "88903235271"
  },
  vapidKey: "BK2UBQ3ZMcStsnjOIAkHlDDxOVyjyF35pRx5CYS7W93uu2hUsPirS71wsoqEiorJM7JNR0Hp3iHCZXFlgQkA5Vc"
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
